// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cb-passkey-list-container {
  display: flex;
  flex-direction: column;
  margin: 1.25rem 0rem;
  text-align: left;
}

.cb-passkey-list-title {
  font-size: calc(var(--cb-base-font-size) * 1.9);
  margin: 0.5rem 0rem 2rem 0rem;
}

.cb-passkey-list-card {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  border-radius: var(--cb-border-radius-sm);
  border: var(--cb-passkey-list-border-color) 1px solid;
  margin: 0.5rem 0;
  padding: 1.75rem 0.5rem;
  background-color: var(--cb-white);
  line-height: 1.4;
}

.cb-passkey-list-card:hover {
  border: var(--cb-passkey-list-border-hover-color) 1px solid;
}

.cb-passkey-list-icon {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.cb-passkey-list-icon-left img {
  width: 2rem;
  height: 2rem;
}

.cb-passkey-list-icon svg {
  width: 2rem;
  height: 2rem;
  fill: var(--cb-text-primary-color);
}

.cb-passkey-list-icon-right img {
  width: 2rem;
  height: 2rem;
}

.cb-passkey-list-details {
  flex: 10;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cb-passkey-list-header {
  display: flex;
  gap: 2.5rem;
}

.cb-passkey-list-header-title {
  margin: auto 0;
  font-size: calc(var(--cb-base-font-size) * 1.9);
  font-family: var(--cb-primary-font);
}

.cb-passkey-list-header-badge-section {
  margin: auto 0;
  display: flex;
  gap: 0.5rem;
}

.cb-passkey-list-header-badge-top-section {
  display: none;
}

.cb-passkey-list-header-badge {
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  border-radius: var(--cb-border-radius-lg);
  border: none;
  color: var(--cb-passkey-list-badge-color);
  background-color: var(--cb-passkey-list-badge-background-color);
  padding: 0.35rem 0.7rem;
  margin: auto;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}

.cb-passkey-list-header-badge-icon {
  flex: 2;
  height: 1rem;
}

.cb-passkey-list-header-badge-text {
  flex: 10;
  font-weight: 500;
  white-space: nowrap;
  overflow: visible;
  color: var(--cb-passkey-list-badge-color);
  font-family: var(--cb-secondary-font);
  font-size: calc(var(--cb-base-font-size) * 1.25);
}

.cb-passkey-list-description-text {
  color: var(--cb-passkey-list-description-text-color);
  font-family: var(--cb-secondary-font);
  font-size: calc(var(--cb-base-font-size) * 1.5);
}

.cb-passkey-list-delete:hover {
  fill: var(--cb-error-text-color);
  cursor: pointer;
}

button.cb-passkey-list-primary-button {
  margin-top: 1.25rem;
  max-width: 225px;
  height: 2.5rem;
  display: flex;
  gap: 0.35rem;
  align-items: center;
  justify-content: center;
  font-size: calc(var(--cb-base-font-size) * 1.9);
  font-weight: 500;
}

button.cb-passkey-list-primary-button .cb-icon {
  height: 1.6rem;
}

@media screen and (max-width: 481px) {
  .cb-passkey-list-tile {
    font-size: 14px;
  }

  .cb-passkey-list-card {
    gap: 0.25rem;
    padding: 1.5rem 0.5rem 0.8rem;
    line-height: 1.2;
  }

  .cb-passkey-list-details {
    gap: 0.2rem;
  }

  .cb-passkey-list-header-title {
    font-size: 14px;
  }

  .cb-passkey-list-description-text {
    font-size: 12px;
  }

  .cb-passkey-list-header-badge-section.cb-has-multiple-badges {
    display: none;
  }

  .cb-passkey-list-header-badge-top-section.cb-has-multiple-badges {
    display: flex;
    gap: 0.5rem;
    align-self: flex-start;
    flex-wrap: wrap;
    margin-bottom: 0.3rem;
  }

  .cb-passkey-list-header-badge {
    gap: 0.25rem;
    padding: 0.2rem 0.5rem;
  }

  .cb-passkey-list-header-badge-icon {
    height: 0.8rem;
  }

  .cb-passkey-list-header-badge-text {
    font-size: 10px;
  }

  .cb-passkey-list-icon {
    flex: 2;
  }

  .cb-passkey-list-details {
    flex: 8;
  }

  .cb-passkey-list-icon-right img {
    width: 1.5rem;
  }

  button.cb-passkey-list-primary-button {
    font-size: 14px;
    font-weight: 500;
    max-width: 160px;
    height: 2.2rem;
  }

  button.cb-passkey-list-primary-button .cb-icon {
    height: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/passkey-list.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,qDAAqD;EACrD,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,yCAAyC;EACzC,+DAA+D;EAC/D,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,oDAAoD;EACpD,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".cb-passkey-list-container {\n  display: flex;\n  flex-direction: column;\n  margin: 1.25rem 0rem;\n  text-align: left;\n}\n\n.cb-passkey-list-title {\n  font-size: calc(var(--cb-base-font-size) * 1.9);\n  margin: 0.5rem 0rem 2rem 0rem;\n}\n\n.cb-passkey-list-card {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  border-radius: var(--cb-border-radius-sm);\n  border: var(--cb-passkey-list-border-color) 1px solid;\n  margin: 0.5rem 0;\n  padding: 1.75rem 0.5rem;\n  background-color: var(--cb-white);\n  line-height: 1.4;\n}\n\n.cb-passkey-list-card:hover {\n  border: var(--cb-passkey-list-border-hover-color) 1px solid;\n}\n\n.cb-passkey-list-icon {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n}\n\n.cb-passkey-list-icon-left img {\n  width: 2rem;\n  height: 2rem;\n}\n\n.cb-passkey-list-icon svg {\n  width: 2rem;\n  height: 2rem;\n  fill: var(--cb-text-primary-color);\n}\n\n.cb-passkey-list-icon-right img {\n  width: 2rem;\n  height: 2rem;\n}\n\n.cb-passkey-list-details {\n  flex: 10;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.cb-passkey-list-header {\n  display: flex;\n  gap: 2.5rem;\n}\n\n.cb-passkey-list-header-title {\n  margin: auto 0;\n  font-size: calc(var(--cb-base-font-size) * 1.9);\n  font-family: var(--cb-primary-font);\n}\n\n.cb-passkey-list-header-badge-section {\n  margin: auto 0;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.cb-passkey-list-header-badge-top-section {\n  display: none;\n}\n\n.cb-passkey-list-header-badge {\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: row;\n  border-radius: var(--cb-border-radius-lg);\n  border: none;\n  color: var(--cb-passkey-list-badge-color);\n  background-color: var(--cb-passkey-list-badge-background-color);\n  padding: 0.35rem 0.7rem;\n  margin: auto;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n}\n\n.cb-passkey-list-header-badge-icon {\n  flex: 2;\n  height: 1rem;\n}\n\n.cb-passkey-list-header-badge-text {\n  flex: 10;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: visible;\n  color: var(--cb-passkey-list-badge-color);\n  font-family: var(--cb-secondary-font);\n  font-size: calc(var(--cb-base-font-size) * 1.25);\n}\n\n.cb-passkey-list-description-text {\n  color: var(--cb-passkey-list-description-text-color);\n  font-family: var(--cb-secondary-font);\n  font-size: calc(var(--cb-base-font-size) * 1.5);\n}\n\n.cb-passkey-list-delete:hover {\n  fill: var(--cb-error-text-color);\n  cursor: pointer;\n}\n\nbutton.cb-passkey-list-primary-button {\n  margin-top: 1.25rem;\n  max-width: 225px;\n  height: 2.5rem;\n  display: flex;\n  gap: 0.35rem;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(var(--cb-base-font-size) * 1.9);\n  font-weight: 500;\n}\n\nbutton.cb-passkey-list-primary-button .cb-icon {\n  height: 1.6rem;\n}\n\n@media screen and (max-width: 481px) {\n  .cb-passkey-list-tile {\n    font-size: 14px;\n  }\n\n  .cb-passkey-list-card {\n    gap: 0.25rem;\n    padding: 1.5rem 0.5rem 0.8rem;\n    line-height: 1.2;\n  }\n\n  .cb-passkey-list-details {\n    gap: 0.2rem;\n  }\n\n  .cb-passkey-list-header-title {\n    font-size: 14px;\n  }\n\n  .cb-passkey-list-description-text {\n    font-size: 12px;\n  }\n\n  .cb-passkey-list-header-badge-section.cb-has-multiple-badges {\n    display: none;\n  }\n\n  .cb-passkey-list-header-badge-top-section.cb-has-multiple-badges {\n    display: flex;\n    gap: 0.5rem;\n    align-self: flex-start;\n    flex-wrap: wrap;\n    margin-bottom: 0.3rem;\n  }\n\n  .cb-passkey-list-header-badge {\n    gap: 0.25rem;\n    padding: 0.2rem 0.5rem;\n  }\n\n  .cb-passkey-list-header-badge-icon {\n    height: 0.8rem;\n  }\n\n  .cb-passkey-list-header-badge-text {\n    font-size: 10px;\n  }\n\n  .cb-passkey-list-icon {\n    flex: 2;\n  }\n\n  .cb-passkey-list-details {\n    flex: 8;\n  }\n\n  .cb-passkey-list-icon-right img {\n    width: 1.5rem;\n  }\n\n  button.cb-passkey-list-primary-button {\n    font-size: 14px;\n    font-weight: 500;\n    max-width: 160px;\n    height: 2.2rem;\n  }\n\n  button.cb-passkey-list-primary-button .cb-icon {\n    height: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
